import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkOptionDisabledTeacherSubjectLevel',
})
export class CheckOptionDisabledTeacherSubjectLevelPipe
  implements PipeTransform
{
  transform(currentLevelId: any, ...args: any[]): any {
    const currentLesson = args[0];
    const lessonsLevels = args[1];

    let lessonLevel = lessonsLevels.find(
      (lessonsLevel: any) =>
        lessonsLevel.lesson_id === currentLesson.study_lesson
    );

    if (lessonLevel) {
      const level = lessonLevel.levels.find(
        (level: any) => level.id === currentLevelId
      );
      if (level) {
        switch (level.state) {
          case 0:
            return 'level-pending';
            break;
          case 1:
            return 'level-accepted';
            break;
          case 2:
            return 'level-canceled';
            break;
        }
      } else {
        return '';
      }
    } else {
      return '';
    }
  }
}
